import React from 'react';
import { ShieldCheckIcon, CalendarCheckIcon, BookOpenIcon, MailIcon } from 'lucide-react';
import { offer } from '../../data/offer';
export function Guarantee() {
  if (!offer.guaranteeDays) return null;
  const days = offer.guaranteeDays;
  const badges = [{
    icon: CalendarCheckIcon,
    label: `${days} days to decide`
  }, {
    icon: BookOpenIcon,
    label: 'Review the plan & bonuses'
  }, {
    icon: MailIcon,
    label: 'Refund on request'
  }];
  return <section aria-labelledby="guarantee-heading" className="bg-forest" data-id="element-86" data-mp="2efdwjmhbkoad">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center md:py-24" data-id="element-87" data-mp="2jaji2k6t80xx">
        <div className="mx-auto flex h-32 w-32 flex-col items-center justify-center rounded-full border-4 border-gold bg-deep" data-id="element-88" data-mp="2oc8tw21uwin2">
          <ShieldCheckIcon aria-hidden="true" className="h-7 w-7 text-gold" data-id="element-89" data-mp="2sbzs2qtpq11m" />
          <span className="font-display text-5xl font-extrabold leading-none text-white" data-id="element-90" data-mp="ty7thcqnrnkv">{days}</span>
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-91" data-mp="xzjc2yb478jk">Days</span>
        </div>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-92" data-mp="3smzox48cthz4">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-5xl font-extrabold uppercase leading-[0.92] text-white md:text-7xl" data-id="element-93" data-mp="3nt5b2hffjx7y">
          {days}-day <span className="text-gold" data-id="element-94" data-mp="3dxlh40kff8lu">guarantee</span>
        </h2>
        <p className="mt-6 text-xl font-semibold text-white" data-id="element-95" data-mp="fewr1xqz4ere">
          Open everything. Use the material. Put it to the test in your classes.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-96" data-mp="agcznhtm2arn">
          If HYROX MEGA PACK™ isn't right for your classes, contact the store within {days} days of your purchase to
          request your refund.
        </p>
        <ul className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-97" data-mp="2q6pt7ej3cxjv">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 border border-moss bg-deep px-4 py-2 text-sm font-semibold text-white" data-id="element-98" data-mp="2l7lk0nw62ztj">
              <Icon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-99" data-mp="1h9rb1vmnztto" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}